import { seoConfig, panelModes } from "@/mocks/panelContent";
import { FieldRow, LockedButton, PanelBadge, PanelCard, ReadOnlyNotice } from "../components/PanelUI";

export default function SeoSection() {
  return (
    <div className="flex flex-col gap-6">
      <ReadOnlyNotice text={panelModes.viewNotice} />

      <PanelCard
        title="SEO e compartilhamento"
        description="Título, descrição, endereço canônico e imagem de compartilhamento."
        action={<PanelBadge tone="primary">{seoConfig.robots}</PanelBadge>}
      >
        <div className="grid grid-cols-1 gap-x-8 lg:grid-cols-2">
          <div className="rounded-md border border-background-200 bg-background-100 px-3 py-1">
            <FieldRow label="Title" value={seoConfig.title} />
            <FieldRow label="Description" value={seoConfig.description} />
            <FieldRow label="Canonical" value={seoConfig.canonical} />
            <FieldRow label="Indexação" value={seoConfig.robots} />
            <FieldRow label="Favicon" value={seoConfig.favicon} />
          </div>
          <div>
            <p className="mb-2 text-[11px] uppercase tracking-[0.14em] text-foreground-500">
              Imagem Open Graph
            </p>
            <div className="h-[200px] w-full overflow-hidden rounded-md border border-background-200 bg-background-100">
              <img
                src={seoConfig.ogImage}
                alt="Imagem de compartilhamento Amora Belle"
                title="Open Graph — Amora Belle"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>
        </div>
        <div className="mt-4">
          <LockedButton icon="ri-edit-2-line" hint="Alterações apenas pela administração Vellora">
            Editar SEO
          </LockedButton>
        </div>
        <p className="mt-3 text-[11px] leading-relaxed text-foreground-500">
          A indexação deve permanecer como index, follow, sem aplicar noindex ou nofollow, pois a
          página é utilizada em anúncios.
        </p>
      </PanelCard>
    </div>
  );
}